<template>
    <div class="card">
        <div class="card-header bg-transparent d-flex flex-row align-items-center" v-if="$slots.header">
            <slot name="header"/>
        </div>
        <div class="card-body">
            <slot/>
        </div>
        <div class="card-footer" v-if="$slots.footer">
            <slot name="footer"/>
        </div>
    </div>
</template>
